var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "magic-zoom" } }, [
    _c(
      "div",
      { attrs: { itemscope: "", itemtype: "http://schema.org/Thing" } },
      [
        _c(
          "div",
          {
            staticClass: "ItemImgWrap justify-content-center",
            class: [
              { "more-images": _vm.magiczoom.images.all.length > 1 },
              { "d-none": _vm.gallery !== true },
              { "hundredYearBadge-box": _vm.hundredYears }
            ]
          },
          [
            _vm.magiczoom.images.all.length > 1
              ? [
                  _vm.variationImages > 4 || _vm.variationImages.length > 4
                    ? _c(
                        "div",
                        { staticClass: "magic-more-images d-none d-lg-block" },
                        [
                          _vm.magiczoom.images.all.length > 4
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-center fa-lg mb-2 cursor",
                                  on: { click: _vm.slidePrev }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-angle-right fa-rotate-270 flipiconZoom "
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "hooper",
                            {
                              ref: "carousel",
                              staticClass: "d-none d-lg-block",
                              attrs: {
                                vertical: true,
                                infiniteScroll: false,
                                itemsToShow: 4,
                                trimWhiteSpace: true
                              }
                            },
                            [
                              _vm.ytvideo != ""
                                ? _c("slide", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "border video d-flex mb-2 videoImage cursor",
                                        on: {
                                          click: function($event) {
                                            return _vm.showVideo()
                                          },
                                          "~mouseover": function($event) {
                                            return _vm.$store.dispatch(
                                              "loadComponent",
                                              "yt-video"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        !_vm.loading
                                          ? _c("i", {
                                              staticClass: "fa fa-play-circle-o"
                                            })
                                          : _c("i", {
                                              staticClass:
                                                "fa fa-circle-o-notch fa-spin"
                                            })
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.variationImages, function(
                                imagePreview,
                                index
                              ) {
                                return _c("slide", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "border",
                                      attrs: {
                                        "aria-label": "variationImages" + index,
                                        href: "variationImages[index].url",
                                        rel: "zoom-id:ItemImgZoom",
                                        "data-image":
                                          _vm.variationImages[index].urlMiddle
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          loading: "lazy",
                                          "data-src": imagePreview.url,
                                          src: imagePreview.urlPreview,
                                          alt:
                                            _vm.magiczoom.texts.name1 +
                                            " - " +
                                            index,
                                          title:
                                            _vm.magiczoom.texts.name1 +
                                            " - " +
                                            index
                                        }
                                      })
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.magiczoom.images.all.length > 4
                            ? _c(
                                "div",
                                {
                                  staticClass: "text-center fa-lg cursor",
                                  on: { click: _vm.slideNext }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-angle-right fa-rotate-90"
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "magic-more-images d-none d-lg-block" },
                        [
                          _vm.ytvideo != ""
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "border video d-flex mb-2 videoImage",
                                    on: {
                                      click: function($event) {
                                        return _vm.showVideo()
                                      },
                                      "~mouseover": function($event) {
                                        return _vm.$store.dispatch(
                                          "loadComponent",
                                          "yt-video"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    !_vm.loading
                                      ? _c("i", {
                                          staticClass: "fa fa-play-circle-o"
                                        })
                                      : _c("i", {
                                          staticClass:
                                            "fa fa-circle-o-notch fa-spin"
                                        })
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.variationImages, function(
                            imagePreview,
                            index
                          ) {
                            return [
                              _c(
                                "a",
                                {
                                  staticClass: "mb-2 border",
                                  attrs: {
                                    "aria-label": "variationImages" + index,
                                    href: _vm.variationImages[index].url,
                                    rel: "zoom-id:ItemImgZoom",
                                    "data-image":
                                      _vm.variationImages[index].urlMiddle
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      loading: "lazy",
                                      "data-src": imagePreview.url,
                                      src: imagePreview.urlPreview,
                                      alt:
                                        _vm.magiczoom.texts.name1 +
                                        " - " +
                                        index,
                                      title:
                                        _vm.magiczoom.texts.name1 +
                                        " - " +
                                        index
                                    }
                                  })
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass:
                  "MagicZoomPlus flex-fill d-flex align-items-start justify-content-center",
                attrs: {
                  "aria-label": _vm.$translate(
                    "Woerner::Template.singleZoomHint"
                  ),
                  href: _vm._f("itemImage")(
                    _vm._f("itemImages")(_vm.magiczoom.images, "url")
                  ),
                  id: "ItemImgZoom",
                  "data-mobile-options":
                    "zoomMode:off; lazyZoom: true; textTouchZoomHint:" +
                    _vm.$translate("Woerner::Template.singleZoomHint") +
                    "; textClickZoomHint: " +
                    _vm.$translate("Woerner::Template.singleZoomHint2") +
                    "; textExpandHint: " +
                    _vm.$translate("Woerner::Template.singleZoomHint"),
                  "data-options":
                    "lazyZoom: true;cssClass: white-bg; zoom-height:500px; textHoverZoomHint:" +
                    _vm.$translate("Woerner::Template.singleZoomHint3") +
                    "; textExpandHint:" +
                    _vm.$translate("Woerner::Template.singleZoomHint3") +
                    "; zoomPosition: #zoom-placeholder;"
                }
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: {
                    alt: "middleImage",
                    src: _vm._f("itemImage")(
                      _vm._f("itemImages")(_vm.magiczoom.images, "urlMiddle")
                    ),
                    itemprop: "image"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _vm.hundredYears
              ? [
                  _c("div", { staticClass: "hundredYearBadge-box" }, [
                    _c("img", {
                      staticClass: "hundredYearBadge",
                      attrs: {
                        alt: "100 years",
                        src:
                          "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/100Jahre_Icon_" +
                          _vm.lang.toUpperCase() +
                          ".png",
                        loading: "lazy"
                      }
                    })
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.geticons.hasOwnProperty("84")
              ? _c(
                  "div",
                  { staticClass: "item-characters d-flex" },
                  [
                    _vm._l(_vm.geticons[84], function(icon) {
                      return [
                        icon.id == 1503
                          ? [
                              _c("div", { staticClass: "character" }, [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/SingleIcons/icon_schwerentflammbar.gif",
                                    alt: "schwerentflammbar"
                                  }
                                })
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        icon.id == 1506
                          ? [
                              _c("div", { staticClass: "character" }, [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "https://cdn02.plentymarkets.com/xlzn8fmweulj/frontend/Onlineshop/images/SingleIcons/icon_aussen_innen.gif",
                                    alt: "fuer aussenanwendung"
                                  }
                                })
                              ])
                            ]
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.magiczoom.prices.rrp &&
        _vm.magiczoom.prices.rrp.price.value > 0 &&
        _vm.magiczoom.prices.rrp.price.value >
          _vm.magiczoom.prices.default.price.value
          ? [
              _c("div", { staticClass: "item-special-icon reduced" }, [
                _vm._v("\n        %\n      ")
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.gallery != true
          ? [
              _c("div", [
                _c("iframe", {
                  attrs: {
                    width: "100%",
                    height: "315",
                    src:
                      "https://www.youtube-nocookie.com/embed/" + _vm.ytvideo,
                    title: "YouTube video player",
                    frameborder: "0",
                    allow:
                      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: ""
                  }
                })
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.gallery == true
          ? [
              _c(
                "div",
                { staticClass: "zoom-navigation-dots d-lg-none" },
                [
                  _vm._l(_vm.dotsCount, function(dot) {
                    return [_c("div", { staticClass: "dot" })]
                  })
                ],
                2
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.ytvideo != "" && _vm.gallery != true
          ? [
              _c(
                "div",
                { staticClass: "d-md-none text-center my-3 ybbGalleryBtn" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          _vm.gallery = true
                        }
                      }
                    },
                    [
                      _vm._v("\n          Gallery anzeigen "),
                      _c("i", { staticClass: "fa fa-picture-o ml-3" })
                    ]
                  )
                ]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.ytvideo != "" && _vm.gallery == true
          ? [
              _c("div", { staticClass: "d-md-none text-center my-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: {
                      click: function($event) {
                        _vm.gallery = false
                      }
                    }
                  },
                  [
                    _vm._v("\n          Video abspielen "),
                    _c("i", { staticClass: "fa fa-play-circle-o ml-3" })
                  ]
                )
              ])
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.geticons[83], function(icon) {
          return _vm.geticons.hasOwnProperty("83")
            ? [
                icon.id == 1499
                  ? [
                      _c("div", { staticClass: "item-special-icon reduced" }, [
                        _vm._v("\n          %\n        ")
                      ])
                    ]
                  : _vm._e()
              ]
            : _vm._e()
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }